module.exports = __webpack_public_path__ + "static/mr-concert-performance-26-8f294e8653396aef094174e708e9d17b.jpg";